<template>
  <div>
    <v-navigation-drawer
      v-if="showNavigationDrawer"
      expand-on-hover
      :mobile-breakpoint="customMobileBreakpoint"
      color="primary"
      app
      clipped
    >
      <v-divider></v-divider>
      <!-- Elementos de menú con enrutamiento -->
      <v-list nav dense v-for="item in routedItems" :key="item.id">
        <router-link :to="item.router" exact>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="red">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="color: red">{{
              item.text
            }}</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>
      <!-- Elementos de menú con componentes -->
      <v-list nav dense v-for="item in componentItems" :key="item.id">
        <v-list-item
          link
          @click="loadComponent(item.component), emitEvent(item.text)"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: white">{{
            item.text
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div>
      <component :is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
import Liquidacion from "../relations/FormEdit.vue";
import Instancias from "../relations/Instances.vue";
import Conceptos from "../relations/Concepts.vue";
import CentroDeCostos from "../relations/CostCenters.vue";
import Empleados from "../relations/Employees.vue";
import Grupos from "../relations/Groups.vue";
import Firmas from "../relations/Firms.vue";
import ReglasDePreLiquidacion from "../relations/PreSettlementRules.vue";
import ReglasDeLiquidacion from "../relations/SettlementRules.vue";
import ReglasDeAjuste from "../relations/AdjusmentRules.vue";

export default {
  props: {
    showNavigationDrawer: Boolean,
  },
  data() {
    return {
      customMobileBreakpoint: 300,
      routedItems: [],
      componentItems: [
        {
          text: "Liquidación",
          icon: "mdi-folder-table",
          id: 1,
          component: Liquidacion,
        },
        {
          text: "Instancias",
          icon: "mdi-swap-vertical-bold",
          id: 2,
          component: Instancias,
        },
        {
          text: "Conceptos",
          icon: "mdi-account-wrench",
          id: 3,
          component: Conceptos,
        },
        {
          text: "Centro de costos",
          icon: "mdi-folder-home",
          id: 4,
          component: CentroDeCostos,
        },
        {
          text: "Empleados",
          icon: "mdi-account-lock",
          id: 5,
          component: Empleados,
        },
        { text: "Grupos", icon: "mdi-group", id: 6, component: Grupos },
        { text: "Firmas", icon: "fa-pen-nib", id: 7, component: Firmas },
        {
          text: "Reglas de pre-liquidación",
          icon: "fa-ruler",
          id: 8,
          component: ReglasDePreLiquidacion,
        },
        {
          text: "Reglas de liquidación",
          icon: "fa-ruler",
          id: 9,
          component: ReglasDeLiquidacion,
        },
        {
          text: "Reglas de ajuste",
          icon: "mdi-progress-wrench",
          id: 10,
          component: ReglasDeAjuste,
        },
      ],
      currentComponent: Liquidacion,
    };
  },
  methods: {
    loadComponent(component) {
      this.currentComponent = component;
    },
    emitEvent(texto) {
      this.$emit("nameItem", texto);
    },
  },
};
</script>
